import { lazy } from "react";

export { NOTIFICATION_TEMPLATE_EDITOR_PATH } from "./notification-template-editor-path";
export const NotificationTemplateEditorPage = lazy(
  () => import("./notification-template-editor"),
);
